import Numpad from './numpad';
import './numpad.scss';

export default Numpad;
